//React Imports
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";

// MUI Imports

// Other Libraries
import "react-datepicker/dist/react-datepicker.css";

// Project Imports
import { useQubBringValue } from "context/bringValueContext";
import { useFormContext } from "react-hook-form";
import TextInput from "./TextInput";

const BringValueInput = (props) => {
  const { openBringValue } = useQubBringValue();
  const { ...other } = props;
  const { setValue } = useFormContext();

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      openBringValue({
        datakey: "APIPelPromExpl",
        title: "Συναλασσόμενοι",
        callback: (value) => {
          for (const v in value) {
            setValue(`${v}`, value[v]);
          }
        },
      });
    }
  };

  return (
    <TextInput
      onKeyPress={(e) => handleKeyPress(e)}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <Search style={{ height: 18 }} />
          </InputAdornment>
        ),
      }}
      {...other}
    />
  );
};

export default BringValueInput;
